/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TimeClockIcon16Light = forwardRef('TimeClockIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8 4.402a.5.5 0 0 0-1 0v2.325c0 .663.375 1.27.967 1.566l2.31 1.154a.5.5 0 1 0 .447-.894l-2.31-1.155A.75.75 0 0 1 8 6.728V4.401Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.5 1a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM2 7.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0Z" })));
});
